import { gsap, ScrollTrigger } from 'gsap/all'

const scrollAnimations = {
  el: {
    boxCards: document.querySelectorAll<HTMLElement>('.box-cards'),
    eventCards: document.querySelectorAll<HTMLElement>('.events__content'),
    footer: document.querySelectorAll<HTMLElement>('.footer'),
    imageBlockSectionImages: document.querySelectorAll<HTMLElement>('.image-block-section .image'),
    infoBlocks: document.querySelectorAll<HTMLElement>('.info-block'),
    infoBlockImages: document.querySelectorAll<HTMLElement>('.info-block .info-image'),
    landingBlockSectionImages: document.querySelectorAll<HTMLElement>('.landing-block-section .image-wrapper'),
    navigationBoxes: document.querySelectorAll<HTMLElement>('.navigation-boxes'),
    sections: document.querySelectorAll<HTMLElement>('.main > section, .footer'),
  },

  init(): void {
    // this.animate(this.el.imageBlockSectionImages, this.parallaxImage)
    this.animate(this.el.infoBlockImages, this.parallaxImage)
    this.animate(this.el.landingBlockSectionImages, this.parallaxImage)

    this.animate(this.el.boxCards, this.revealElements, '.boxes-block-box')
    this.animate(this.el.eventCards, this.revealElements, '.events-card')
    this.animate(this.el.infoBlocks, this.revealElements, '.timestamp, .heading, .text-column--text, .button')
    this.animate(this.el.navigationBoxes, this.revealElements, '.navigation-box')

    this.animate(this.el.sections, this.revealSection)

    setTimeout(() => {
      ScrollTrigger.refresh()
    }, 123)
  },

  animate(items, functionName, elements = {}): void {
    if (items[0]) {
      items.forEach((item) => {
        functionName(item, elements)
      })
    }
  },

  parallaxImage(imageWrap): void {
    gsap.to(imageWrap.querySelector('img'), {
      ease: 'none',
      scale: imageWrap.classList.contains('info-image') ? 1.23 : 1.123,
      scrollTrigger: {
        end: '100% 0',
        scrub: 2.34,
        start: '0 100%',
        trigger: imageWrap,
      },
    })
  },

  revealElements(section, elements): void {
    if (!section.querySelectorAll(elements)[0]) return

    gsap.fromTo(
      section.querySelectorAll(elements),
      {
        opacity: 0,
        y: 0,
      },
      {
        duration: 1.23,
        ease: 'power3.out',
        opacity: 1,
        scrollTrigger: {
          start: '0 67%',
          toggleActions: 'play none resume reverse',
          trigger: section,
        },
        stagger: 0.07,
        y: 0,
      }
    )
  },

  revealSection(section): void {
    gsap.fromTo(
      section.children,
      {
        opacity: 0,
        y: section.classList.contains('footer') ? 0 : 0,
      },
      {
        duration: 1.23,
        ease: 'power3.out',
        opacity: 1,
        scrollTrigger: {
          start: '0 87%',
          toggleActions: 'play none resume reverse',
          trigger: section,
        },
        y: 0,
      }
    )
  },
}

export default scrollAnimations
